'use client';

import type { AppLanguage } from '@/i18n/resources';
import type { Resource } from 'i18next';
import { I18nProvider } from 'next-i18next/client';
import type { ReactNode } from 'react';

import ModalContainer from '@/components/shared/ui/modals/ModalContainer';
import ToastContainer from '@/components/shared/ui/toasts/ToastContainer';

type Props = {
  children: ReactNode;
  language: AppLanguage;
  resources: Resource;
};

export default function PageI18nProvider({
  children,
  language,
  resources,
}: Props) {
  return (
    <I18nProvider
      defaultNS="common"
      fallbackLng={language}
      language={language}
      resources={resources}
      supportedLngs={[language]}
    >
      {children}
      <ToastContainer />
      <ModalContainer />
    </I18nProvider>
  );
}
